/**
 * Inicializa PhotoSwipe en la galería del PDP.
 * Transición fluida: anima desde la imagen principal (thumbEl) y posición del clic.
 */
(function () {
  if (typeof window.PhotoSwipeLightbox === 'undefined' || typeof window.PhotoSwipe === 'undefined') return;

  var gallery = document.querySelector('.product-gallery');
  var pswpRoot = gallery && gallery.querySelector('.product-gallery__pswp');
  var pswpLinks = pswpRoot ? pswpRoot.querySelectorAll('a[data-pswp-width]') : [];
  if (!pswpRoot || pswpLinks.length === 0) return;

  var lightbox = new window.PhotoSwipeLightbox({
    gallery: '.product-gallery__pswp',
    children: 'a[data-pswp-width]',
    pswpModule: window.PhotoSwipe,
    bgOpacity: 0.7,
    bgClickAction: 'close',
    tapAction: function (pt, e) {
      if (!e.target || !e.target.classList || !e.target.classList.contains('pswp__img')) {
        this.close();
      }
    },
    showHideAnimationType: 'zoom',
    showAnimationDuration: 400,
    hideAnimationDuration: 350,
    easing: 'cubic-bezier(0.4, 0, 0.22, 1)'
  });

  /* Animación desde la imagen principal visible (como en Vogue) */
  lightbox.addFilter('thumbEl', function (thumbEl, data, index) {
    var link = pswpLinks[index];
    if (!link) return thumbEl;
    var mediaIndex = link.getAttribute('data-media-index');
    var item = gallery.querySelector('.product-gallery__item[data-media-index="' + mediaIndex + '"]');
    if (item) {
      var img = item.querySelector('.product-gallery__img');
      return img || item;
    }
    return thumbEl;
  });

  /* Placeholder = imagen ya visible en galería, transición más fluida */
  lightbox.addFilter('placeholderSrc', function (placeholderSrc, content) {
    var index = content.index;
    var link = pswpLinks[index];
    if (!link) return placeholderSrc;
    var mediaIndex = link.getAttribute('data-media-index');
    var item = gallery.querySelector('.product-gallery__item[data-media-index="' + mediaIndex + '"]');
    if (item) {
      var img = item.querySelector('.product-gallery__img');
      if (img && (img.currentSrc || img.src)) return img.currentSrc || img.src;
    }
    return placeholderSrc;
  });

  lightbox.init();

  lightbox.on('afterInit', function () {
    var pswp = this.pswp;
    if (!pswp) return;
    var bg = pswp.bg || document.querySelector('.pswp__bg');
    if (bg) {
      bg.addEventListener('click', function () {
        if (pswp && !pswp.destroyed) pswp.close();
      });
    }
  });

  function openAtMediaIndex(mediaIndex, pointerPos) {
    var links = Array.prototype.slice.call(pswpLinks);
    var i = links.findIndex(function (a) { return a.getAttribute('data-media-index') === String(mediaIndex); });
    if (i < 0) return;
    var opts = { gallery: pswpRoot };
    lightbox.loadAndOpen(i, opts, pointerPos);
  }

  gallery.querySelectorAll('.product-gallery__item').forEach(function (item) {
    item.addEventListener('click', function (e) {
      if (!item.querySelector('.product-gallery__img')) return;
      var pos = { x: e.clientX, y: e.clientY };
      openAtMediaIndex(item.getAttribute('data-media-index'), pos);
    });
  });
})();
